import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-customer-en',
  templateUrl: './help-customer-en.component.html',
  styleUrls: ['help-customer-en.component.scss']
})
export class HelpCustomerEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
